import { useEffect, useState } from 'react';
import { Trans, type TransProps } from 'react-i18next';

import {
    Body1,
    Button,
    Checkbox,
    HorizontalDivider,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { OnHoldConfig } from '../../../configuration/shared';

type ConfirmUnholdModalProps = {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    isLoading: boolean;
    config: Omit<
        NonNullable<OnHoldConfig['holdScreen']['confirmModal']>,
        'body'
    > & { body: string[] };
    values?: TransProps<string>['values'];
};

export const ConfirmUnholdModal = ({
    opened,
    onClose,
    onConfirm,
    isLoading,
    config,
    values,
}: ConfirmUnholdModalProps) => {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        if (!opened) setIsChecked(false);
    }, [opened]);

    const handleConfirm = async () => {
        try {
            await onConfirm();
        } finally {
            onClose();
        }
    };

    return (
        <Modal title={config.title} opened={opened} onClose={onClose}>
            <Stack>
                {config.body.map((line) => (
                    <Body1 key={line}>
                        <Trans ns="dynamic" values={values}>
                            {line}
                        </Trans>
                    </Body1>
                ))}
                <HorizontalDivider />
                <Checkbox
                    checked={isChecked}
                    onChange={setIsChecked}
                    label={<Body1>{config.checkboxLabel}</Body1>}
                />
                <Button
                    disabled={!isChecked}
                    loading={isLoading}
                    onClick={handleConfirm}
                >
                    {config.buttonLabels.confirm}
                </Button>
            </Stack>
        </Modal>
    );
};
